import { Box, Link, Text } from '@stitch-fix/mode-react';
export const ErrorMessage = () => <Box my={1}>
    <Text setting="body-small-fixed" color="red-50">
      Something went wrong! Don’t worry, we can still sign you up for Stitch
      Fix.&nbsp;
      <Link href="https://support.stitchfix.com/hc/en-us/requests/new">
        Contact us here
      </Link>
      .
    </Text>
  </Box>;